import React, { useState, useEffect } from 'react';
import './Readingchallenge.css';

import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

const images = importAll(require.context('../Assets/homeimg', false, /\.(png|jpe?g| jpeg| svg)$/));

export default function Courses(props) {
  const { pathname } = useLocation();
  const [btnarray, setbtnarray] = useState([]);
  const baseurlapi = props.baseurlapi;
  const [AllCourses, setAllCourses] = useState([]);
  const [WinningEditions, setWinning] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get(baseurlapi + '/Courses.php')
      .then(response2 => {
        setAllCourses(response2.data.AllCourses)

        setLoading(false);
      })
    window.scrollTo(0, 0);
  }, [pathname]);


  const clickbtn = id => () => {

    setbtnarray([...btnarray, id]);
  }



  return (
    <>
      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="container-fluid bgcolorFFFFFF p-t-20 border-1px">

          <div className="container2 ">
            <div className="row">
              <div className="col-md-12">
                <h4 className='mb-2  color214545 fw-bold text-center mb-3'>Word Ninjas Creative Writing Classes  </h4>
              </div>
            </div>



            <div className="row mt-0">

              {AllCourses.map((AB, index) => (
                <div className="col-md-4 " key={index} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                  <div style={{ margin: '30px', marginTop: '7px' }} className="bgcolorFFF8E6 b-r-30">
                    <img src={AB.image} className="w-100  b-r-30 previouscontestimg" />
                    <h5 className="mt-3 fw-bold  fw-normal p-l-10 PoppinsLight">{AB.coursename.substring(0, 40) + '...'}</h5>
                    <div className="p-l-10 text-center mt-15" >
                      <Link to={`/coursedetails/${AB.id}`} className="bgcolor enrollbtn t-decoration-none color000 mt-5 PoppinsLight">View Course</Link>
                    </div>
                    <br />
                  </div>
                </div>
              ))}
            </div>


          </div>

          <div className="container2 mt-4 mb-5" >
            <div className="row bgFEEDB5 border-radius-25 padding-desktop" style={{paddingBottom:'20px'}}>
              <h4 className="text-center fw-bold mt-4 mb-4">About the Facilitator</h4>

              <div className="card  w-100-imp mb-4 b-none border-radius-25">

                <div className="card-body pd-10">
                  <div className='row boardofadvisorysection text-center mt-3'>
                    <div className="col-md-3">
                      <img src={images['Tejaswini.jpeg']} height={100} width={120} className="boardofadvisoryimage b-r-10P" />
                      <h6 className="card-title fw-bold mt-4">Tejaswini Divya Naik</h6>
                      <p className="m-b-none f-s-13 PoppinsLight">Writer | Creative Strategist | Media Professional | Educator</p>
                    </div>

                    <div className="col-md-9">
                      <div className='justify-content-center d-flex'>
                        <div className='text-left'>

                          <p className="m-b-none f-s-13 PoppinsLight">📚 Author of national & Amazon bestsellers: Smokes and Whiskey & One for Sorrow</p>

                          <p className="m-b-none f-s-13 PoppinsLight">🎥 Former VP - Creative at Saibaba Studios | 13+ years in media, film, and storytelling</p>

                          <p className="m-b-none f-s-13 PoppinsLight">🧠 Founder of TDN (personal brand + merch), Satin and Gold (SNG – luxury lifestyle & IP lab), and Social Media Waale (a creator-first digital & branding agency)</p>

                          <p className="m-b-none f-s-13 PoppinsLight">📚 Runs a creative writing program for children and young adults across India. 200+ hours of Creative writing classes engaged.</p>

                          <p className="m-b-none f-s-13 PoppinsLight">💡 Specialist in narrative design, brand strategy, content development, and digital IPs</p>

                          <p className="m-b-none f-s-13 PoppinsLight">✨ Shaping stories, building brands, and mentoring the next generation of creative minds</p>

                          <p className="m-b-none f-s-13 PoppinsLight">📍Lives in Mumbai, India and Pune, India</p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>



            </div>
          </div>


        </div>
      )}


    </>
  )
}